export default "__VITE_ASSET__CqdVOED5__"